import React from "react"
import { useTranslation } from "react-i18next"
import {
  SharingEmail,
  Email,
  Note,
  Status,
} from "./styled/TimelineEventDetails"
import { formatVars } from "../../helpers/translation"
import DateDisplay from "./DateDisplay"

const UploadDetails = ({ shareMethod, recipients, createdAt, isExpired }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  return (
    <>
      {isExpired && (
        <div>
          <Status $isExpired={true}>{t("##.Transfers.Expired")}</Status>
        </div>
      )}
      {shareMethod === "link" && <span>{t("##.Timeline.SharedLink")}</span>}
      {shareMethod === "email" && (
        <SharingEmail>
          <span>{t("##.Timeline.SharedWith")}</span>
          <Email>{recipients[0].email}</Email>
          {recipients.length > 1 && (
            <span>
              {formatVars(language, t("##.Timeline.AndOthers"), {
                COUNT: recipients.length - 1,
              })}
            </span>
          )}
        </SharingEmail>
      )}
      <Note as={DateDisplay} date={createdAt}>
        {t("##.Timeline.CreatedOn")}
      </Note>
    </>
  )
}

export default UploadDetails
